/**
 * @file Barrel for the shared search body extracted in SE-7242.
 * @module features/global-search/components/organisms/GlobalSearchBody
 */
export { default } from "./GlobalSearchBodyView";
export { EMPTY_RESULTS_SUBTITLE } from "./GlobalSearchBodyView";
export type { GlobalSearchBodyViewProps } from "./GlobalSearchBodyView";
